// PromotionModal.jsx
import React, { useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';

const PromotionModal = ({ isOpen, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
        
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div 
            className="promotion-modal-overlay"
            onClick={onClose}
        >
            <div 
                className="promotion-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <button 
                    className="close-button"
                    onClick={onClose}
                    aria-label="Close"
                    type="button"
                >
                    <AiOutlineClose size={28} />
                </button>
                
                <div className="promotion-content">
                    <img 
                        src="https://i.ibb.co/zTjCsrYb/wine-menu-page-0001-1.jpg" 
                        alt="Special Promotion" 
                        className="promotion-image"
                    />
                </div>
            </div>
        </div>
    );
};

export default PromotionModal;